import { ServiceConfig } from 'shared/models/service-configs';

export const qaServiceConfig: ServiceConfig = {
  clientId: '9a565907-72fc-4c10-8c07-883463e5faa4',
  tenantId: 'c9340d0a-8762-4b43-a2d1-f59bd6ef8726',
};
